export class TypeStructure {
    id: number;
    name: string;
}


